import { Component, OnInit,Input } from '@angular/core';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service'
import { ToastrService } from 'ngx-toastr';
import {  Router } from '@angular/router';
import { EditBidModalComponent } from 'src/app/shared/components/edit-bid-modal/edit-bid-modal.component';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-edit-confirm-bid',
    templateUrl: './edit-confirm-bid.component.html',
    styleUrls: ['./edit-confirm-bid.component.scss'],
    imports: [NgIf, NgFor, FormsModule, DecimalPipe, DatePipe, I18nModule]
})
export class EditConfirmBidComponent implements OnInit {
  @Input() finalQPFromDate:any;
  @Input() finalQPToDate:any;
  private modalRef: NgbModalRef;
  COI: boolean =false;
  ITB: boolean= false;
  OpenNegotiation:boolean=true;
  @Input() datePeriod:any;
  @Input() price:number;
  @Input() indexPrice:number;
  @Input() code:any;
  @Input() quantity:any;
  productInfo:any;
  product:any;
  requestTenders:any[]=[];
  disabledBtn = false;
  biddingTerms = '';
  requestParams: any;
  enableLoader: boolean = false;
  @Input() quantityshw:number;
  @Input() dischargePortshw:number;
  confirmTxt:string=null;

  constructor(private customProductService: CustomProductsService,public activeModal: NgbActiveModal,private Modal:NgbModal,  private router: Router,
    private customProductsService: CustomProductsService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.product=this.datePeriod;
    this.biddingTerms=this.datePeriod?this.datePeriod.buyerRemarks:'';
    console.log(this.datePeriod.buyerRemarks,'bt')
     this.customProductsService.getConfirmtxt().subscribe((txt)=>{
      this.confirmTxt = txt;
    })
    // this.productInfo=this.code;
    if(this.datePeriod?.combinedTenders.length ==1){
    this.productInfo=this.code;
  }else{
    this.productInfo=this.code[0];
  }
  if (this.datePeriod.groupTenders) {
    this.datePeriod.combinedchildlist = [...this.productInfo.childList]
  }
  if (this.datePeriod.groupTenders == undefined) {
  this.requestParams = {
    "quoteAction": "EDIT_BID",
    "tender": {   
      "quoteCode": this.product.quoteCode,
      "tenderEntries": [
        {  
          "quantity": this.productInfo?.isQuantityUnrestricted== true? this.quantityshw: this.productInfo.quantity,
          "dischargePortDetails": this.productInfo?.isDischargePortUnrestricted == true ? this.dischargePortshw : this.productInfo.dischargePortDetails,
          "entryNumber": this.productInfo.entryNumber,
          "finalQPFromDate":this.productInfo.isQuotationPeriodUnrestricted==true || this.productInfo.isQPMultipleChoicesSelected == true?this.productInfo.finalQPFromDate:'',
            "finalQPToDate":this.productInfo.isQuotationPeriodUnrestricted==true || this.productInfo.isQPMultipleChoicesSelected == true?this.productInfo.finalQPToDate:'',
          "pricingOptionsEnum": [
            {
              "pricingOptions": this.productInfo.pricingOptionsEnum[0].pricingOptions,
              "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp
            }
          ],
          "productCode":  this.productInfo.productCode,
          "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp,
          [this.productInfo.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'?'relativePrice':'premiumDiscount']: {
            "currencyIso": "USD",
            "value":this.price,
           }
        }
      ]
    }
  }
}
else {
  this.datePeriod.combinedchildlist.map((val)=>{
    this.requestTenders.push({ 
              "quantity": val?.isQuantityUnrestricted== true?val.quantityshw: val.quantity,
              "dischargePortDetails": val?.isDischargePortUnrestricted == true ? val.dischargePortDetails : '',
              "entryNumber": val.entryNumber,
              "finalQPFromDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPFromDate:'',
              "finalQPToDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPToDate:'',
              "pricingOptionsEnum": [
                {
                  "pricingOptions": val.pricingOptionsEnum[0].pricingOptions,
                  "qpMultipleChoices": val.pricingOptionsEnum[0].qp
                }
              ],
              "productCode":  val.productCode,
              "qpMultipleChoices": val.pricingOptionsEnum[0].qp,
              [val.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'?'relativePrice':'premiumDiscount']: {
                "currencyIso": "USD",
                "value":val.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'?val.priceshw:val.indexPriceshw,
               }
    })
  })
}
  }
  submit(price): any {
    if(this.datePeriod.groupTenders){
      this.requestParams={
        "quoteAction": "EDIT_BID",
      "tender": {
        "buyerRemarks": this.biddingTerms,   
        "quoteCode": this.product.quoteCode,
        "tenderEntries": this.requestTenders
      }
    }
    } 
    if(this.productInfo.minimumQuantity && this.productInfo.maximumQuantity){
      this.requestParams.tender.tenderEntries[0].quantity=this.quantity
     }
    //console.log(this.requestParams);
    //this.requestParams.tender.quoteEntries[0].relativePrice.value = parseFloat(price);
    this.requestParams.tender.buyerRemarks = this.biddingTerms;
    if(this.productInfo.isQuotationPeriodUnrestricted== true){
      this.requestParams.tender.tenderEntries[0].finalQPFromDate=this.finalQPFromDate
      this.requestParams.tender.tenderEntries[0].finalQPToDate=this.finalQPToDate
    }
    
      if (this.productInfo.commodityType == 'IO') {
        if (this.requestParams.tender.tenderEntries[0].premiumDiscount){
          if (this.requestParams.tender.tenderEntries[0].premiumDiscount?.value == '' || this.requestParams.tender.tenderEntries[0].premiumDiscount?.value == undefined) {
            this.requestParams.tender.tenderEntries[0].premiumDiscount.value = 0;
          }
        }
      }
    
    console.log(this.requestParams);
    this.disabledBtn = true;
    this.enableLoader = true;
    this.customProductsService.submitTender(this.requestParams).subscribe(resp=>{
      console.log(resp);
      if(resp.status === "BID_PLACED"){
        this.enableLoader = false;
        this.homeLinkClick(false);
        //this.toastrService.show(resp.status);
        this.activeModal.close();
        this.customProductService.bidPlaced = true;
        const currentUrl = this.router.url;
          if (currentUrl === '/quotes/myquotes') {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
          });
          }else{
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl] );
            });
          }
      }else{
        this.enableLoader = false;
        this.toastrService.show(resp.status?resp.status:"Sorry something went wrong!");
      }
    },
    err=>{
      this.enableLoader = false;
      this.activeModal.close();
      this.toastrService.show(err?.error.errors?err.error.errors[0].message:'Something went wrong while submitting the tender, please contact support team');
    })
    
  }
  homeLinkClick(value): any {
    this.customProductService.getHomeLinkActive(value);
  }
  backToPlacebid(): any{
    this.activeModal.close();
    const ModalRef = this.Modal.open(EditBidModalComponent,{centered: true,size:'md'});
    this.productInfo.finalQPFromDate=this.finalQPFromDate
    this.productInfo.finalQPToDate=this.finalQPToDate
    if(this.productInfo.minimumQuantity && this.productInfo.maximumQuantity){
      ModalRef.componentInstance.quantity=this.quantity;
     }
     if(this.productInfo.pricingOptionsEnum[0]?.qp){
      ModalRef.componentInstance.defaultValue = this.productInfo?.pricingOptionsEnum[0]?.qp[0]?.description;
      if(ModalRef.componentInstance.defaultValue == 'Fixed QP'){
        ModalRef.componentInstance.displayFixedQPSection = true;
        ModalRef.componentInstance.finalQPFromDate=this.finalQPFromDate;
        ModalRef.componentInstance.finalQPToDate=this.finalQPToDate;
      }else{
        ModalRef.componentInstance.displayFixedQPSection = false;
      }
    }
    if (this.datePeriod?.combinedTenders.length ==1){
      ModalRef.componentInstance.productsInfo=this.datePeriod;
      ModalRef.componentInstance.price=this.price;
        ModalRef.componentInstance.indexPrice=this.price;
        ModalRef.componentInstance.quantityshw=this.quantityshw;
        ModalRef.componentInstance.dischargePortshw=this.dischargePortshw;
          }else{
            ModalRef.componentInstance.selectProduct=this.datePeriod;
            ModalRef.componentInstance.productsEntry=this.code;
            ModalRef.componentInstance.price=this.price;
          }
  }
  getDate(date){
    if(date){
      var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
      return formateDate;
    }
    else{
      return '';
    }
  }
  formatQPDates(data){
    return this.customProductService.formatQPDates(data);
  }
  getPricingBasisBasedOnOption(pricingOption,description){
    return this.customProductService.getPricingBasisBasedOnOption(pricingOption,description)
  }
  getLabelofConfirmScreen(priceOptions,commodityType,page){
    return this.customProductService.getLabelofConfirmScreen(priceOptions,commodityType,page);

  }
  getPriceandSymbol(priceOptions,price,commodityType){
  return this.customProductService.getPriceandSymbol(priceOptions,price,commodityType);
  }
}
